"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOpCard = void 0;
exports.sendRemoteAuth = sendRemoteAuth;
exports.updateSaveCardFlag = updateSaveCardFlag;

var _postRobot = _interopRequireDefault(require("post-robot"));

var _zoid = require("zoid/dist/zoid.frameworks");

var _util = require("../util/util");

var _constants = require("../util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateSaveCardFlag(saveCard) {
  var iframes = document.getElementsByTagName('iframe');

  for (var i = 0; i < iframes.length; i++) {
    var iframeName = iframes[i].name;

    if (iframeName && iframeName.indexOf('zoid__card_sdk') > 0) {
      _postRobot.default.send(window.frames[iframeName], 'updateSaveCardFlag', saveCard);

      break;
    }
  }
}

function sendRemoteAuth(billingInfo) {
  console.log('Sending remote auth');
  var iframes = document.getElementsByTagName('iframe');

  for (var i = 0; i < iframes.length; i++) {
    var iframeName = iframes[i].name;

    if (iframeName && iframeName.indexOf('zoid__card_sdk') > 0) {
      _postRobot.default.send(window.frames[iframeName], 'sendAuth', billingInfo);

      break;
    }
  }
}

var createOpCard = (0, _zoid.create)({
  tag: 'card-sdk',
  dimensions: {
    width: '100%',
    height: '215px'
  },
  url: function url(_ref) {
    var props = _ref.props;
    return (0, _util.getUrl)(props.env);
  },
  props: {
    env: {
      type: 'string',
      required: true,
      validate: function validate(_ref2) {
        var value = _ref2.value,
            props = _ref2.props;

        if ([_constants.ENV_LOCAL, _constants.ENV_DEV, _constants.ENV_QA, _constants.ENV_AUTOMATION, _constants.ENV_PROD].indexOf(value) < 0) {
          var propError = {
            reasonCode: _constants.ZOID_VALIDATION_ENV_ERROR,
            description: _constants.PROP_VALIDATION_ERROR
          };
          props.info(propError);
          throw new TypeError(propError);
        }
      }
    },
    clientId: {
      type: 'string',
      required: true
    },
    clientToken: {
      type: 'string',
      required: true
    },
    storeNumber: {
      type: 'string',
      required: true
    },
    storeZipCode: {
      type: 'string',
      required: true
    },
    amount: {
      type: 'number',
      required: true
    },
    countryCode: {
      type: 'string',
      required: false,
      default: function _default() {
        return 'US';
      }
    },
    languageCode: {
      type: 'string',
      required: false,
      default: function _default() {
        return 'en-US';
      }
    },
    orderNumber: {
      type: 'string',
      required: true
    },
    transactionOptions: {
      type: 'object',
      required: false,
      default: function _default() {
        return {
          preAuthorize: false
        };
      }
    },
    billingAddress: {
      type: 'object',
      required: false
    },
    cssStyles: {
      type: 'string',
      required: false
    },
    saveCard: {
      type: 'boolean',
      required: false,
      default: function _default() {
        return false;
      }
    },
    sdkVersion: {
      type: 'string',
      required: false,
      default: function _default() {
        return '1.8.1';
      }
    },
    info: {
      type: 'function',
      required: true
    },
    success: {
      type: 'function',
      required: true
    }
  },
  // autoresize card component to make it responsive
  autoResize: {
    width: false,
    height: true,
    element: '#root'
  }
});
exports.createOpCard = createOpCard;